import { render, staticRenderFns } from "./ToDoorTemplatePage.vue?vue&type=template&id=32243a66&scoped=true"
import script from "./ToDoorTemplatePage.vue?vue&type=script&lang=js"
export * from "./ToDoorTemplatePage.vue?vue&type=script&lang=js"
import style0 from "./ToDoorTemplatePage.vue?vue&type=style&index=0&id=32243a66&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32243a66",
  null
  
)

export default component.exports